import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import LoadingIndicator from "../../simple/LoadingIndicator/LoadingIndicator";
import { ModalView } from "../../simple";
import Map from "./AudienceMap";

function ModalMap(props) {
  const {
    data,
    changeModalState,
    isOpen,
    mapClassName,
    mapCenter,
    mapZoom,
    // country,
    isMapLayoutLoading,
    // mapLayouts,
    ...restProps
  } = props;

  return (
    <ModalView
      toggle={changeModalState}
      handleClose={changeModalState}
      isOpen={isOpen}
      {...restProps}
    >
      <div className={mapClassName}>
        {!isMapLayoutLoading ? (
          <Map mapLayout={data} mapCenter={mapCenter} mapZoom={mapZoom} />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <LoadingIndicator />
          </div>
        )}
      </div>
    </ModalView>
  );
}

ModalMap.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  changeModalState: PropTypes.func.isRequired,
  mapClassName: PropTypes.string.isRequired,
  // country: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isMapLayoutLoading: PropTypes.bool.isRequired,
  mapCenter: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }).isRequired,
  mapZoom: PropTypes.number.isRequired
};

const mapStateToProps = ({ audienceSlice }) => ({
  isMapLayoutLoading: audienceSlice.isMapLayoutLoading
  // mapLayouts: audiences.map
});

export default connect(mapStateToProps)(ModalMap);
